import { Component, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { BaseProblem, DialogReportProblemComponent } from "../dialog-report-problem/dialog-report-problem";
import { ApiHelper } from "../../../helpers/apihelper";

@Component({
  selector: "dialog-send-diagnostics",
  templateUrl: "./dialog-send-diagnostics.html",
  styleUrls: [
    "../dialog-domain-add/dialog-domain-add.scss",
    "../dialog-domain-add/options/domain-option-available/domain-option-available.scss",
  ],
  imports: [TranslateModule, FormsModule, AngularSvgIconModule, DialogReportProblemComponent],
})
export class DialogSendDiagnosticsComponent {
  private readonly api = inject(ApiHelper);
  protected isResultState = signal(false);
  protected isErrorState = signal(false);

  protected submit(base: BaseProblem) {
    this.api
      .fileDiagnosticReport(base)
      .then((result) => {
        this.isErrorState.set(false);
      })
      .catch((err) => {
        this.isErrorState.set(true);
      })
      .finally(() => {
        this.isResultState.set(true);
      });
  }
}
